<span class="field-view-value">{{formattedDateTime || '—'}}</span>
